import axios, { AxiosRequestConfig } from "axios";
import { Token, tokenKey, SystemRole, LoginUser } from "../types/authentication";
import { ThunkDispatch } from "redux-thunk";
import { StoreState } from "../store/storeState";
import { AnyAction } from "redux";
import { authenticateSuccess } from "../actions/authActions";
import * as Cookies from "js-cookie";
import AppContextActions from "../actions/appContextActions";
import { Branch } from "src/common/types/branch";

export const checkAuthorizationStatus = () => {
  let token = sessionStorage.getItem(tokenKey) || null;
  if (token == null) {
    token = Cookies.get(tokenKey) || null;
  }
  return token;
};

export const handleAuthentication = (token: Token, dispatch: ThunkDispatch<StoreState, void, AnyAction>) => {
  axios.interceptors.request.use((config: AxiosRequestConfig) => {
    return addAuthorizationHeader(config);
  });

  const user: LoginUser = {
    id: token.sub,
    name: token.name,
    email: token.email,
    username: token.username,
    role: token.role as SystemRole,
    permissions: token.permission && token.permission instanceof Array ? token.permission : [token.permission],
    branchId: token.branchId,
    branches: token.branches
  };

  dispatch(
    authenticateSuccess(user)
  );

  const authorizedBranches = getAuthorizedBranches(user);
  if (authorizedBranches.length > 0) {
    dispatch(
      AppContextActions.updateAppContext({
        branchId: authorizedBranches[0]
      })
    );
  }
};

export const mapBranchesToUser = (user: LoginUser, branches: Branch[]) => {

  if (user && user.role === SystemRole.ResourceAdmin) {
    const availableBranches: Branch[] = [];
    const branchIds: string[] = getAuthorizedBranches(user);

    if (branches && branches.length > 0) {
      branches.forEach(b => {
        const index = branchIds.indexOf(b.id.toString());
        if (index >= 0) {
          availableBranches.push(b);
        }
      })
    }

    return availableBranches;
  }

  return branches;
}

export const getAuthorizedBranches = (user: LoginUser): string[] => {
  let branches: string[] = [];

  if (user.branches) {
    if (user.branches.length > 0) {
      user.branches.forEach(b => {
        branches.push(b);
      });
    }
  } else if (user.branchId) {
    branches.push(user.branchId);
  }

  return branches;
}

const addAuthorizationHeader = (config: AxiosRequestConfig): AxiosRequestConfig => {
  const token = checkAuthorizationStatus();
  return { ...config, headers: { ...config.headers, Authorization: `Bearer ${token}` } };
};
